// LICENSE_CODE ZON
'use strict'; /*jslint node:true, es6:true, react:true*/
import React, {useState, useEffect, useCallback, useContext} from 'react';
import cn from 'classnames';
// @ts-ignore
import _debounce from 'lodash.debounce';
// @ts-ignore
import {Trans as T, useTranslation} from 'react-i18next';
// @ts-ignore
import {capitalize} from '/util/string.js';
import etask from '/util/etask.js';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import styles from './pass_meter.module.less';
import {Settings_context} from '../../../../hola/pub/settings_ctx';

const default_messages = {
    'weak': 'Weak',
    'medium': 'Medium',
    'perfect': 'Strong',
};

export const Pass_meter = props=>{
    useTranslation();
    const {theme} = useContext(Settings_context);
    const {pass, email, bars,
        messages = default_messages, show_messages = true} = props;
    const [strength, set_strength] = useState('empty');
    const msg = messages[strength] || capitalize(strength);
    const check_pass = useCallback(_debounce((_pass, _e)=>etask(function*(){
        if (!_pass)
            return void set_strength('empty');
        try {
            const res = yield fetch('/users/check_pass', {
                method: 'POST',
                body: {pass: _pass, email: _e},
            });
            set_strength(res == 'good' ? 'medium' : res);
        } catch(e){}
    }), 500), []);
    useEffect(()=>{ check_pass(pass, email); }, [pass, email]);
    const cls = cn(
        'pass_meter',
        styles.wrapper,
        styles.wrapper_2023,
        styles[strength],
    );
    return <div className={cls}>
        <div className={styles.meter_2023}>
          {bars ? <div className={styles.bars} data-role="bars">
            <div className={cn(styles.bar, styles.bar1)}/>
            <div className={cn(styles.bar, styles.bar2)}/>
            <div className={cn(styles.bar, styles.bar3)}/>
          </div> : <div className={styles.filler}/>}
          {show_messages && strength != 'empty' &&
            <p className={theme.p12} data-role="strength">
            Password strength: <b><T>{msg}</T></b></p>}
          <p className={theme.p12}>
            Select at least 8 characters,
            a combination of upper and lower-case letters,
            numbers and special characters.
          </p>
      </div>
    </div>;
};
